export * from './adm-resource.service';
import { AdmResourceService } from './adm-resource.service';
export * from './app-version-resource.service';
import { AppVersionResourceService } from './app-version-resource.service';
export * from './bank-resource.service';
import { BankResourceService } from './bank-resource.service';
export * from './brand-resource.service';
import { BrandResourceService } from './brand-resource.service';
export * from './call-resource.service';
import { CallResourceService } from './call-resource.service';
export * from './callcenter-resource.service';
import { CallcenterResourceService } from './callcenter-resource.service';
export * from './cashbox-resource.service';
import { CashboxResourceService } from './cashbox-resource.service';
export * from './catalog-address-resource.service';
import { CatalogAddressResourceService } from './catalog-address-resource.service';
export * from './catalog-card-resource.service';
import { CatalogCardResourceService } from './catalog-card-resource.service';
export * from './catalog-section-resource.service';
import { CatalogSectionResourceService } from './catalog-section-resource.service';
export * from './catalog-uncovered-resource.service';
import { CatalogUncoveredResourceService } from './catalog-uncovered-resource.service';
export * from './category-resource.service';
import { CategoryResourceService } from './category-resource.service';
export * from './city-resource.service';
import { CityResourceService } from './city-resource.service';
export * from './client-resource.service';
import { ClientResourceService } from './client-resource.service';
export * from './coin-resource.service';
import { CoinResourceService } from './coin-resource.service';
export * from './confectionery-resource.service';
import { ConfectioneryResourceService } from './confectionery-resource.service';
export * from './contract-resource.service';
import { ContractResourceService } from './contract-resource.service';
export * from './country-contacts-resource.service';
import { CountryContactsResourceService } from './country-contacts-resource.service';
export * from './country-resource.service';
import { CountryResourceService } from './country-resource.service';
export * from './date-property-resource.service';
import { DatePropertyResourceService } from './date-property-resource.service';
export * from './delivery-resource.service';
import { DeliveryResourceService } from './delivery-resource.service';
export * from './delivery-zone-resource.service';
import { DeliveryZoneResourceService } from './delivery-zone-resource.service';
export * from './dgis-resource.service';
import { DgisResourceService } from './dgis-resource.service';
export * from './dictionary-resource.service';
import { DictionaryResourceService } from './dictionary-resource.service';
export * from './employee-contract-resource.service';
import { EmployeeContractResourceService } from './employee-contract-resource.service';
export * from './event-resource.service';
import { EventResourceService } from './event-resource.service';
export * from './faq-resource.service';
import { FaqResourceService } from './faq-resource.service';
export * from './feedback-resource.service';
import { FeedbackResourceService } from './feedback-resource.service';
export * from './file-resource.service';
import { FileResourceService } from './file-resource.service';
export * from './google-resource.service';
import { GoogleResourceService } from './google-resource.service';
export * from './group-resource.service';
import { GroupResourceService } from './group-resource.service';
export * from './identity-resource.service';
import { IdentityResourceService } from './identity-resource.service';
export * from './invoice-resource.service';
import { InvoiceResourceService } from './invoice-resource.service';
export * from './order-resource.service';
import { OrderResourceService } from './order-resource.service';
export * from './organization-resource.service';
import { OrganizationResourceService } from './organization-resource.service';
export * from './payment-approval-resource.service';
import { PaymentApprovalResourceService } from './payment-approval-resource.service';
export * from './permission-resource.service';
import { PermissionResourceService } from './permission-resource.service';
export * from './price-resource.service';
import { PriceResourceService } from './price-resource.service';
export * from './product-info-resource.service';
import { ProductInfoResourceService } from './product-info-resource.service';
export * from './product-resource.service';
import { ProductResourceService } from './product-resource.service';
export * from './product-split-definition-resource.service';
import { ProductSplitDefinitionResourceService } from './product-split-definition-resource.service';
export * from './promo-banner-resource.service';
import { PromoBannerResourceService } from './promo-banner-resource.service';
export * from './reaction-resource.service';
import { ReactionResourceService } from './reaction-resource.service';
export * from './recipe-resource.service';
import { RecipeResourceService } from './recipe-resource.service';
export * from './rejection-resource.service';
import { RejectionResourceService } from './rejection-resource.service';
export * from './report-resource.service';
import { ReportResourceService } from './report-resource.service';
export * from './royalty-resource.service';
import { RoyaltyResourceService } from './royalty-resource.service';
export * from './squareup-resource.service';
import { SquareupResourceService } from './squareup-resource.service';
export * from './storage-invoice-resource.service';
import { StorageInvoiceResourceService } from './storage-invoice-resource.service';
export * from './store-encashment-resource.service';
import { StoreEncashmentResourceService } from './store-encashment-resource.service';
export * from './store-product-resource.service';
import { StoreProductResourceService } from './store-product-resource.service';
export * from './store-resource.service';
import { StoreResourceService } from './store-resource.service';
export * from './store-work-time-resource.service';
import { StoreWorkTimeResourceService } from './store-work-time-resource.service';
export * from './supplier-resource.service';
import { SupplierResourceService } from './supplier-resource.service';
export * from './tag-resource.service';
import { TagResourceService } from './tag-resource.service';
export * from './timesheet-resource.service';
import { TimesheetResourceService } from './timesheet-resource.service';
export * from './unit-of-measure-resource.service';
import { UnitOfMeasureResourceService } from './unit-of-measure-resource.service';
export * from './user-resource.service';
import { UserResourceService } from './user-resource.service';
export * from './user-setting-resource.service';
import { UserSettingResourceService } from './user-setting-resource.service';
export * from './webkassa-resource.service';
import { WebkassaResourceService } from './webkassa-resource.service';
export * from './workflow-resource.service';
import { WorkflowResourceService } from './workflow-resource.service';
export * from './yandex-resource.service';
import { YandexResourceService } from './yandex-resource.service';
export const APIS = [AdmResourceService, AppVersionResourceService, BankResourceService, BrandResourceService, CallResourceService, CallcenterResourceService, CashboxResourceService, CatalogAddressResourceService, CatalogCardResourceService, CatalogSectionResourceService, CatalogUncoveredResourceService, CategoryResourceService, CityResourceService, ClientResourceService, CoinResourceService, ConfectioneryResourceService, ContractResourceService, CountryContactsResourceService, CountryResourceService, DatePropertyResourceService, DeliveryResourceService, DeliveryZoneResourceService, DgisResourceService, DictionaryResourceService, EmployeeContractResourceService, EventResourceService, FaqResourceService, FeedbackResourceService, FileResourceService, GoogleResourceService, GroupResourceService, IdentityResourceService, InvoiceResourceService, OrderResourceService, OrganizationResourceService, PaymentApprovalResourceService, PermissionResourceService, PriceResourceService, ProductInfoResourceService, ProductResourceService, ProductSplitDefinitionResourceService, PromoBannerResourceService, ReactionResourceService, RecipeResourceService, RejectionResourceService, ReportResourceService, RoyaltyResourceService, SquareupResourceService, StorageInvoiceResourceService, StoreEncashmentResourceService, StoreProductResourceService, StoreResourceService, StoreWorkTimeResourceService, SupplierResourceService, TagResourceService, TimesheetResourceService, UnitOfMeasureResourceService, UserResourceService, UserSettingResourceService, WebkassaResourceService, WorkflowResourceService, YandexResourceService];
